export const DEMO_EMAIL = 'demo@usd2pay.rangerx.io';
export const DEMO_PASSWORD = 'Usd2pay-Login-Only-24';
export const DEMO_TOKEN = 'usd2pay-login-only-demo-token';
